module.exports = __webpack_public_path__ + "static/cont-music.0797cbfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cont-music.jpg
// module id = 612
// module chunks = 35783957827783